"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getClientId_1 = __importDefault(require("./getClientId"));
var privacyLink = function (isProduction) {
    if (isProduction === void 0) { isProduction = true; }
    return isProduction ? 'https://privacysettings.schibsted.no/' : 'https://privacysettings-pre-no.schibsted.io/';
};
var getPrivacyLinksByClientShortHandName = function (clientShortHandName, isProduction) {
    if (isProduction === void 0) { isProduction = true; }
    return "".concat(privacyLink(isProduction), "?client_id=").concat((0, getClientId_1.default)(clientShortHandName, isProduction));
};
exports.default = getPrivacyLinksByClientShortHandName;
//# sourceMappingURL=getPrivacyLinksByClientShortHandName.js.map